import QuotePersonalization from './QuotePersonalization';

export type LegacyPersonalCoveragePageProps = {
  /**
   * Apenas Storybook: não faz `GET /Quotes/{hash}`.
   * O decorator deve chamar `applyLegacyPersonalCoverageStorySeed()` (ou equivalente)
   * antes de montar a página para preencher a store.
   */
  storySkipQuoteFetch?: boolean;
};

/** Layout antigo (Container + Header). Use `?legacy=true` ou Storybook «Legado». */
export default function LegacyPersonalCoveragePage({ storySkipQuoteFetch = false }: LegacyPersonalCoveragePageProps) {
  return <QuotePersonalization storySkipQuoteFetch={storySkipQuoteFetch} variant="legacy" />;
}
